import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const api = axios.create({ baseURL: API, withCredentials: true });

// Multi-account scope: every request carries the selected account context.
api.interceptors.request.use((config) => {
  const acc = localStorage.getItem("hussar_account");
  if (acc && !config.url.includes("/auth/")) {
    config.params = { ...(config.params || {}), account: acc };
  }
  return config;
});

let refreshing = null;
api.interceptors.response.use(
  (r) => r,
  async (error) => {
    const original = error.config;
    if (error.response?.status === 401 && !original._retried && !original.url.includes("/auth/")) {
      original._retried = true;
      try {
        refreshing = refreshing || axios.post(`${API}/auth/refresh`, {}, { withCredentials: true })
          .finally(() => { refreshing = null; });
        await refreshing;
        return api(original);
      } catch {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export function apiError(e) {
  const d = e.response?.data?.detail;
  if (d == null) return e.message || "Request failed";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x.msg || JSON.stringify(x)).join(" ");
  return String(d);
}

export const fmtUSD = (v, digits = 2) =>
  v == null ? "—" : new Intl.NumberFormat("en-US", { style: "currency", currency: "USD", minimumFractionDigits: digits, maximumFractionDigits: digits }).format(v);

export const fmtPct = (v, digits = 2) => (v == null ? "—" : `${v >= 0 ? "+" : ""}${Number(v).toFixed(digits)}%`);

export const fmtQty = (v) => (v == null ? "—" : Number(v).toLocaleString("en-US", { maximumFractionDigits: 8 }));

export const fmtTime = (iso) => (iso ? new Date(iso).toLocaleString("en-US", { month: "short", day: "numeric", hour: "2-digit", minute: "2-digit" }) : "—");

export default api;
